import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

// װ��ģ��״̬���壨��̨��
interface BackPackingBatchState extends ListState<any> {
    packingModel: any; // װ��ƻ�ģ�ͣ�����/�༭�ã�
    packingDetailModel: any; // װ������ģ�ͣ��༭װ�������ã�
    id: number;
}

class BackPackingBatchMutations extends ListMutations<any> {
}

class BackPackingBatch extends ListModule<BackPackingBatchState, any, any> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        packingModel: {} as any,
        packingDetailModel: {} as any,
        id: 0
    }

    actions = {
        // 1. ��ȡװ�������б�
        async getPackingBatchList(context: ActionContext<BackPackingBatchState, any>, payload: any) {
            context.state.loading = true;
            const response = await Ajax.get('/api/services/app/PrePlan/GetPackingBatchList', { params: payload.data });
            context.state.loading = false;
            const page = response.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

        // 2. ����װ�䵥
        async createPack(context: ActionContext<BackPackingBatchState, any>, payload: any) {
            await Ajax.post('/api/services/app/PrePlan/CreatePack', payload.data);
        },

        // 3. �༭װ�������Ϣ
        async modifyPackPlan(context: ActionContext<BackPackingBatchState, any>, payload: any) {
            await Ajax.post('/api/services/app/PrePlan/ModifyPackPlan', payload.data);
        },

        // 4. ���װ���Ѵ���
        async processPack(context: ActionContext<BackPackingBatchState, any>, payload: any) {
            await Ajax.post(`/api/services/app/PrePlan/PorcessPack?id=${payload.data.id}`);
        },

        // 5. ����װ�����飨����/�޸�ͨ�ã�
        async savePackingDetails(context: ActionContext<BackPackingBatchState, any>, payload: any) {
            await Ajax.post('/api/services/app/PrePlan/SavePackingDetails', payload.data);
        },

        // 6. ɾ��װ��ƻ�
        async deletePackPlan(context: ActionContext<BackPackingBatchState, any>, payload: any) {
            await Ajax.post(`/api/services/app/PrePlan/DeletePackPlan?id=${payload.data.id}`);
        }
    };

    mutations = {
        setCurrentPage(state: BackPackingBatchState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackPackingBatchState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setPackingModel(state: BackPackingBatchState, model: any) {
            state.packingModel = model;
        },
        setPackingDetailModel(state: BackPackingBatchState, model: any) {
            state.packingDetailModel = model;
        }
    }
}

const backPackingBatch = new BackPackingBatch();
export default backPackingBatch;